import { Link } from "react-router-dom";
import { formatEventDate, gradientFor, styleForCategory } from "../lib/visual";
import type { Event, Venue } from "../types/api";
import styles from "./SpotlightCard.module.css";

type Props = {
  event: Event;
  venue?: Venue;
};

export default function SpotlightCard({ event, venue }: Props) {
  const date = formatEventDate(event.datetime);
  const cat = styleForCategory(event.categoryId);
  const gradient = gradientFor(event.id, event.categoryId);

  return (
    <Link to={`/events/${event.id}`} className={styles.card}>
      <div className={styles.bg} style={{ background: gradient }} aria-hidden>
        <span className={styles.glyph}>{cat.glyph}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.kicker}>
          <span className={styles.kickerDot} />
          Spotlight · {cat.shortLabel}
        </div>
        <h3 className={styles.title}>{event.name}</h3>
        <div className={styles.meta}>
          <span>{date.full}</span>
          <span className={styles.dot}>·</span>
          <span>{date.time}</span>
          {venue && (
            <>
              <span className={styles.dot}>·</span>
              <span>
                {venue.name}, {venue.city}
              </span>
            </>
          )}
        </div>
        <div className={styles.cta}>
          <span className={styles.price}>
            From <strong>${Math.round(event.minPrice)}</strong>
          </span>
          <span className={styles.button}>Get tickets →</span>
        </div>
      </div>
    </Link>
  );
}
